<template>
  <div class="box is-fullwidth" id="containerChart">
    <div id="topApsNone" v-if="this.topAps.avarage.length == 0">
      <span id="textAps">Informação não disponível no momento</span>
    </div>
    <h2 class="is-size-4"><b>Top Vagalumes Acessados</b></h2>
    <apexchart
      ref="chart"
      type="bar"
      height="450"
      :options="this.options"
      :series="getSeries"
    ></apexchart>
  </div>
</template>

<script>
export default {
  name: "apexcharthorizontalbar",
  props: {
    topAps: {
      type: Object
    },
    loading: {
      type: Boolean
    }
  },
  data() {
    return {
      options: {
        series: [
          {
            data: this.topAps
          }
        ],
        chart: {
          type: "bar",
          zoom: {
            enabled: false
          },
          toolbar: {
            show: false
          }
        },

        plotOptions: {
          bar: {
            borderRadius: 4,
            horizontal: true,
            dataLabels: {
              position: "bottom",
              style: {
                colors: ["#000"],
                fontFamily: "sans-serif"
              }
            },
            columnWidth: "70%",
            barHeight: "80%"
          }
        },

        xaxis: {
          categories: [],

          labels: {
            show: false
          }
        },

        dataLabels: {
          enabled: true,
          textAnchor: "start",
          style: {
            fontSize: "15px",
            colors: ["#000"],
            fontFamily: "sans-serif"
          },
          formatter: function(val, opt) {
            return opt.w.globals.labels[opt.dataPointIndex] + ":  " + val + "%";
          },
          offsetX: 0,
          dropShadow: {
            enabled: true
          }
        },
        yaxis: {
          labels: {
            show: false
          }
        },
        tooltip: {
          enabled: false
        }
      }
    };
  },
  computed: {
    getSeries() {
      let series = [
        {
          data: this.topAps.avarage
        }
      ];
      return series;
    }
  },
  beforeUpdate() {
    this.$refs.chart.updateOptions({
      xaxis: {
        categories: this.topAps.name
      }
    });
  }
};
</script>

<style>
@keyframes rotate {
  to {
    transform: rotate(1turn);
  }
}
.IsLoadingTopAps {
  position: absolute;
  z-index: 1;
  width: 90%;
  height: 350px;
  background: #fff;
  opacity: 1;
  display: flex;
  justify-content: center;
}
#loadCircleTopAps {
  align-self: center;
  border: 6px solid black;
  height: 50px;
  width: 50px;
  border-radius: 50%;
  border-top-color: #ff9801;
  animation: rotate 1s infinite;
}

#topApsNone {
  opacity: 0.7;
  background-color: white;
  width: 90%;
  height: 80%;
  z-index: 1;
  display: Flex;
  justify-content: center;
  align-items: center;
  color: #ff9801;
}
#containerChart {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/charts/ApexChartHorizontalBar.vue